"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldOperation = exports.Operation = void 0;
var Operation;
(function (Operation) {
    Operation["SIGN_TRANSACTION"] = "multiversx_signTransaction";
    Operation["SIGN_TRANSACTIONS"] = "multiversx_signTransactions";
    Operation["SIGN_MESSAGE"] = "multiversx_signMessage";
    Operation["SIGN_LOGIN_TOKEN"] = "multiversx_signLoginToken";
})(Operation = exports.Operation || (exports.Operation = {}));
var OldOperation;
(function (OldOperation) {
    OldOperation["SIGN_TRANSACTION"] = "erd_signTransaction";
    OldOperation["SIGN_TRANSACTIONS"] = "erd_signTransactions";
    OldOperation["SIGN_MESSAGE"] = "erd_signMessage";
    OldOperation["SIGN_LOGIN_TOKEN"] = "erd_signLoginToken";
})(OldOperation = exports.OldOperation || (exports.OldOperation = {}));
//# sourceMappingURL=operation.js.map